import { render, staticRenderFns } from "./ReleaseBrief.vue?vue&type=template&id=33125380"
import script from "./ReleaseBrief.vue?vue&type=script&lang=js"
export * from "./ReleaseBrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports